import './search.scss'
import React, { useState, useEffect } from 'react'
import { Search } from '@material-ui/icons'
import styled from '@emotion/styled/macro'
import { Query } from 'react-apollo'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { validateName, parseSearchTerm } from '../../utils/utils'
import { GET_SINGLE_NAME } from '../../graphql/queries'
import Name from '../../components/SingleName/Name'
import Loader from '../../components/Loader'
import SearchErrors from '../../components/SearchErrors/SearchErrors'
import Spinner from 'components/Spinner'
import useDarkMode from 'use-dark-mode'
import mq from 'mediaQuery'
import * as qs from 'qs'
import { useFetchPage } from 'hooks'
import { useLocale } from 'hooks'

const { REACT_APP_STRAPI_API_URL } = process.env

function Searchdomain() {
  const { name: searchTerm } = useParams()
  const { pathname } = useLocation()
  const history = useHistory()
  const darkMode = useDarkMode(true)
  const isDark = darkMode.value

  const { locale } = useLocale()
  const query = qs.stringify({
    locale: [locale],
    populate: {
      searchbutton: {
        fields: ['title']
      },
      registerbutton: {
        fields: ['title']
      },
      requestRegisterButton: {
        fields: ['title']
      },
      registerNowButton: {
        fields: ['title']
      },
      detailsButton: {
        fields: ['title']
      }
    }
  })

  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/avax-domainsearch?${query}`).then(
      res => res.json()
    )

  const { data: contentData, isLoading } = useFetchPage(
    ['api/domain-search', locale],
    fetcher
  )

  // ===============>
  const [valid, setValid] = useState(undefined)
  const [type, setType] = useState(undefined)
  const [name, setNormalisedName] = useState('')
  let errorMessage

  useEffect(() => {
    let normalisedName
    try {
      // This is under the assumption that validateName never returns false
      normalisedName = validateName(searchTerm)
      setNormalisedName(normalisedName)
      document.title = searchTerm
    } catch {
      document.title = 'Error finding name'
    } finally {
      parseSearchTerm(normalisedName || searchTerm).then(_type => {
        if (_type === 'supported' || _type === 'tld' || _type === 'search') {
          setValid(true)
          setType(_type)
        } else {
          if (_type === 'invalid') {
            setType('domainMalformed')
          } else {
            setType(_type)
          }
          setValid(false)
        }
      })
    }
  }, [searchTerm])
  // <===============

  const [inputValue, setInputValue] = useState(null)
  //const [filterOpen, setFilterOpen] = useState(false)
  let input

  const handleParse = e => {
    setInputValue(e.target.value)
  }
  const hasSearch = inputValue && inputValue.length > 0

  return (
    <>
      {isLoading && <Spinner position="fixed" />}

      <Container isDark={isDark} isLoading={isLoading}>
        <H4Bold isDark={isDark}>{contentData?.headtitle}</H4Bold>
        <form
          onSubmit={async e => {
            e.preventDefault()
            if (!hasSearch) return
            const type = await parseSearchTerm(inputValue)
            let searchTerm
            if (input && input.value) {
              searchTerm = input.value.toLowerCase()
            }
            if (!searchTerm || searchTerm.length < 1) {
              return
            }

            if (type === 'address') {
              history.push(`/address/${searchTerm}`)
              return
            }

            input.value = ''
            if (type === 'supported' || type === 'short') {
              history.push(`/name/${searchTerm}`)
              return
            } else {
              history.push(`/search/${searchTerm}`)
            }
          }}
        >
          <FormWrapper>
            <input
              type="search"
              name="search"
              placeholder={contentData?.searchinputplaceholder}
              ref={el => (input = el)}
              onChange={handleParse}
            />
            <Button type="submit" isDark={isDark} disabled={!hasSearch}>
              <Search />
              <H6Bold>{contentData?.searchbutton?.title}</H6Bold>
            </Button>
          </FormWrapper>
        </form>

        {valid && (
          <Query query={GET_SINGLE_NAME} variables={{ name }}>
            {({ loading, error, data, refetch }) => {
              if (loading) return <Loader large center />
              if (error)
                return <div>{(console.log(error), JSON.stringify(error))}</div>

              return (
                <Name
                  details={data.singleName}
                  name={name}
                  pathname={pathname}
                  type={type}
                  refetch={refetch}
                  contentData={contentData}
                />
              )
            }}
          </Query>
        )}
      </Container>
    </>
  )
}

export default Searchdomain

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 64px 24px 84px;
  padding: 30px 25px 25px;
  border: ${({ isDark }) =>
    isDark ? '1px solid #E7303C' : '1px solid #5e17fe'};
  visibility: ${({ isLoading }) => (isLoading ? 'hidden' : '')};
  border-radius: 4px;

  ${mq.medium`
    margin: 64px 40px 84px;
    padding: 30px 40px 40px;
  `}

  ${mq.large`
    margin: 64px 64px 84px;
    padding: 50px 60px 60px;
  `}

  ${mq.xLarge`
    margin: 64px 84px 84px;
    padding: 50px 100px 100px;
  `}

  form {
    width: 100%;
    margin: 140px 0 80px;
  }
`

const H4Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 123.5%;
  letter-spacing: 0.25px;
  color: ${({ isDark }) => (isDark ? '#fff' : '#181818')};
  text-align: center;
`

const H6Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #ffffff;
`

const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  input {
    width: 100%;
    height: 72px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 133.4%;
    color: rgba(0, 0, 0, 0.6);
    padding: 24px;
  }

  ${mq.medium`
    flex-direction: row;

    input {
      width: calc(100% - 268px);
    }
  `}
`

const Button = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 72px;
  background: ${({ isDark }) => (isDark ? '#E7303C' : '#5e17fe')};
  margin-top: 10px;
  border: none;

  &:disabled {
    cursor: not-allowed;
  }

  svg {
    width: 24px;
    height: 24px;
    color: white;
    margin-right: 10px;
  }

  ${mq.medium`width: 268px;margin-top: 0;`}
`
